export default {
    public:{
        subject:'學科',
        author:'作者',
        select: '篩選',
        item:'條',
        keywords:'關鍵詞',
        load:'載入中..',
        nodata:'暫無數據',
        close:'收起',
        all:'全部',
        cancel:'取消',
        traditionalChinese:'繁體中文',
        thai:'泰語',
        indonesian:'印尼語',
        malay:'馬來語',
        filipino:'菲律賓語',

        successful:'註冊成功',
        loginTips: '請登入個人帳號',
        loginSuccess: '登入成功',
        library:'ChatAnswer圖書館AI參考諮詢系統',
        fellows:'ChatFellows機構內同儕發現/引用系統',
        research:'ChatResearch高效個人化的學術探究平台',
        language:'ChatLanguage多語種AI智慧翻譯與語法校對系統',
        document:'ChatDocuments深度文件解析工具',
        data:'ChatData深度表格解析工具',
        other:'其他',
        feedSuccess:'問題回饋成功！',
        codeTips:'驗證碼已發送，請注意查收',
        overtime:'請求超時'
    },
    header:{
        feedback:'問題回饋',
        quit:'退出登錄',
        personal:'登入個人帳號',
        language:'輸出語言',
        username:'用戶名',
        password:'密碼',
        log:'登入',
        noRegistered:'未註冊帳號',
        register:'註冊',
        personalAccount:'註冊個人帳號',
        accountUsername:'帳號/用戶名',
        tips:'請輸入帳號/用戶名',
        tipsPassword:'請輸入密碼',
        confirmPassword:'確認密碼',
        tipsConfirmPassword:'請再次確認密碼',
        email:'信箱',
        tipsEmail:'請輸入信箱',
        phone:'手機號',
        tipsPhone:'請輸入手機號',
        verificationCode:'手機驗證碼',
        tipsVerificationCode:'請輸入手機驗證碼',
        sendVerificationCode:'獲取',
        back:'返回',
        module:'功能模組',
        selectTip:'請選擇存在問題的功能模組',
        question:'問題描述',
        screenshot:'問題截圖',
        upload:'點擊上傳',
        type:'僅支援上傳.jpg/.png格式',
        passwordTip:'請輸入6-24位密碼',
        enterAgain:'請再次輸入密碼',
        inconsistent:'兩次輸入密碼不一致!',
        enterCode:'請輸入驗證碼',
        emailTip:'請輸入正確的信箱地址',
        enterEmail:'請輸入郵件地址',
        otherQuestion:'是否還有與此問題類似的其他疑問',
        example:'例如',
        bibliography:'圖書館書目',
        logOut:'確定退出帳號嗎',
        sure:'確定',
        switching:'切換多語言成功',
        again:'秒後重新發送',
        again2:'',
        hello:'你好'
    },
    login:{
        log:'登 入',
        institutionalLogin:'機 構 登 入',
        personalLogin:'個 人 登 入',
        accountRegistration:'帳號註冊',
        retrievePassword:'找回密碼',
        usernameTip:'請輸入機構用戶名',
        personal:'請輸入個人使用者名稱',
        forget:'忘記密碼？',
        ipLog:'IP 登入',
        institutional:'機構',
        institutionalTip:'請選擇機構',
        country:'國家',
        countryTip:'請選擇國家',
        invitationCode:'邀請碼',
        codeTip: '請輸入邀請碼',
        newPass:'新密碼',
        newPassTip:'請輸入新密碼',
        elmaiCode:'信箱驗證碼',
        elmaiTip:'請輸入信箱驗證碼',
        resetting:'重設密碼',
        logTip: '機構用戶名不能為空',

        truePhone:'請輸入正確的手機號',
        successful:'帳號註冊成功,請重新登入!',
        passwordReset:'密碼重設成功,請重新登入!',

        noteTitle:'獲取驗證碼注意事項：',
        noteOne:'1.為了確保驗證碼能够及時且準確地送達，我們建議使用以下郵箱服務商：Gmail、Outkook、Yahoo；',
        noteTwo:'2.由於各郵件服務商的過濾機制，有時驗證碼郵件可能會被誤判為垃圾郵件或無效郵件，請檢查驗證碼郵件是否存在垃圾郵件回收站中。',
    },
    chatlibrary:{
        questionOne: '查詢圖書館借閱方面的問題',
        questionTwo: '查詢已購資料庫相關問題',
        questionThree: '查詢圖書館數位資源相關問題',
        quickAccess: '快捷訪問',
        disclaimer:'免責聲明',
        further:'進一步提問',
        goon:'繼續',
        statementOne:'1.ChatAnswer的回覆內容基於常見問題回覆與相關資源公開訊息，實際內容以圖書館官方公佈資訊、來源資源官方內容為準。',
        statementTwo:'2.翻譯功能的翻譯結果僅供參考，平台對依賴網站翻譯資訊的準確性或可靠性所造成的任何損失不承擔任何責任；譯文中的內容僅代表原文作者觀點，不代表平台觀點與看法，與平台開發方立場無關。',
        statementThree:'3.語法校對功能僅基於內容的語言學語法問題進行校對，不能達到人工語言潤色的水平，平台對過度依賴語法校對結果所造成的任何損失不承擔任何責任。',
        statementFour:'4.如讀者依據相似性推薦結果進行刊物投稿，投稿前需再次確認期刊資訊並與編輯部聯繫，對盲目依賴網站提供資訊造成的任何損失不承擔任何責任',
        statementFive:'5.讀者上傳的問題、檢索需求、文字、文件的內容中的觀點，不代表平台觀點與看法，與平台開發方立場無關。',
        // 手机端
        statementOneMobile:'1.ChatAnswer的回覆內容基於常見問題回覆與相關資源公開訊息，實際內容以圖書館官方公佈資訊、來源資源官方內容為準。',
        statementTwoMobile:'2.翻譯功能的翻譯結果僅供參考，平台對依賴網站翻譯資訊的準確性或可靠性所造成的任何損失不承擔任何責任；譯文中的內容僅代表原文作者觀點，不代表平台觀點與看法，與平台開發方立場無關。',
        statementThreeMobile:'3.語法校對功能僅基於內容的語言學語法問題進行校對，不能達到人工語言潤色的水平，平台對過度依賴語法校對結果所造成的任何損失不承擔任何責任。',
        statementFourMobile:'4.如讀者依據相似性推薦結果進行刊物投稿，投稿前需再次確認期刊資訊並與編輯部聯繫，對盲目依賴網站提供資訊造成的任何損失不承擔任何責任',
        statementFiveMobile:'5.讀者上傳的問題、檢索需求、文字、文件的內容中的觀點，不代表平台觀點與看法，與平台開發方立場無關。',
        
        // 进入弹窗文本
        hellow:'你好：歡迎你的諮詢，我是',
        introduceOne:'的智能AI助理 ChatAnswer，很高興為你服務。',
        introduceTwo:'1. 圖書館的開放時間',
        introduceThree:'2. 如何尋找數位資源？',
        introduceFour:'3. 所借閱的圖書不慎遺失，怎麼辦？',
        introduceFive:'4. 介紹一下醫學相關的資料庫',
        introduceSix:' 5. 如何在校外存取圖書館數位資源？',
        introduceSeven:'你可以問我有關圖書館的問題，例如你可以問我「如何查詢和找到需要的圖書？」"圖書館開館時間""圖書的借閱規則"等，我會盡可能回答你；還有關於 圖書、資料庫和圖書館其他服務等方面我們也可以進行解答，例如：',
        questions: '進一步提問',
        Continue:'繼續',
        recording:'滑鼠點擊錄音',
        stopRecording:'滑鼠點擊停止錄音',
        microphone:'請先允許該網頁使用麥克風',
        browserTips:'您的瀏覽器不支援語音識別',
        browserTips2:'您的瀏覽器不支援辨識聲音大小',
        progress:'語音辨識中...',
        failed:'語音辨識失敗',
    },
    chatresearch:{
        theme:'ChatResearch | 基於語意的深度發現',
        themeMobile:'基於語意的深度發現',
        switchSemantics:'切換語義檢索',
        switchTraditional: '切換傳統檢索',
        title: '標題',
        results:'精選結果',
        year:'發表年份',
       
        abstract:'摘要',
        tips:'請輸入檢索內容...',
        select:'請選擇',
        issn:'ISSN',
        introduce_tit:'平台介紹',
        introduceOne:'ChatResearch將利用人工智慧和先進技術為讀者提供更全面、個人化與高效的學術探究平台，核心功能包括：',
        introduceTwo:'跨語種語意搜尋系統：透過深度理解讀者的搜尋意圖與興趣，以及跨語言知識映射，ChatResearch平台的跨語種語意搜尋系統將提供更全面、更精準的搜尋結果。',
        introduceThree:'大量文獻管理：批量文獻管理工具可協助研究人員、學者等群體快速處理大量文獻內容，可對文獻進行分類、標註、搜尋、篩選、批註、下載及多種自動化功能，進而大幅提昇文獻管理與科研工作的效率。',
        search:'傳統邏輯檢索',
        searchAll:'搜尋全部',
        searchTip:'您可將摘要全文、來自文獻的段落或詳細描述文字作為檢索內容，系統能夠實現基於語意相似度比對的語意檢索，輸入內容篇幅越長，配對效果越精確。',
        clear:'清空搜尋',
        link:'文章連結',
        Similar:'相似文獻',
        followingresults:'搜尋以下結果',
        chinese:'中文',
        english:'英文',
        total:"傳回結果總量",
        introduceFour:'基於語意分析與相似度相符的學科發現系統，可實現跨語種高效能、智慧檢索',
        volume:'請選擇檢索量',

        inputTips:'目前輸入框內容不能為空！'
    },
    chatlanguage: {
        enter: '輸入',
        errorChecking: '英文查找文法錯誤',
        CToE: '中譯英',
        EToC: '英譯中',
        docTran: '譯採文件翻譯',
        functionIntroduction: '功能介紹',
        introduceOne: '您可以使用「英文尋找文法錯誤」功能對英文文字內容進行智慧文法校對。 輸入內容後，系統能夠實現智慧識別並修正論文中的語法問題，支援對句式、勢態、主謂用法、標點等類型問題的校正，輔助提高文章質量，增強可讀性與表達準確性。',
        introduceTwo: '您可以使用「英語學術潤飾」功能對英文文字進行潤飾與最佳化。 系統會從流暢性和優美性的角度出發，對文字進行修改，使其更加通順、精煉。 為文本增添專業魅力，使得主題思想更為清晰地展現。',
        tips: '請輸入查詢內容',
        basic:'基礎功能',
        polish:'英語學術潤飾',
        inputTips:'請輸入需要校對或是潤色的文字內容',

        againRequest:'請求失敗!請重試!',
    },
    chatfellows:{
        introduceOne:'成果智能發現平台 —— 站在前輩肩膀上',
        introduceTwo:'平台簡介',
        introduceThree_one:'ChatFellows',
        introduceThree_two:'成果智慧發現平台是一款專為',
        introduceThree:'科學研究人員打造的智慧學術檢索工具。 基於機構成果的全面集成，應用語義相似度計算、向量化技術、自然語言感知等技術，實現成果的深層、多維度利用，實現智能精準的結果匹配、相似度排序，並實現跨語種檢索與 匹配，有效協助科研人員進行學術文獻研究、參考文獻檢索、投稿期刊選擇等科研發文工作的進行。',
        introduceFour:'ChatFellows 成果智能發現平台全面整合匯集了我校重點研究成果，透過智慧AI技術的深層應用，實現成果的有效應用，輔助科研工作的有效開展。 致力於幫助使用者快速且準確地找到相關領域的優質論文，提高研究效率，並協助學術成果的取得。 站在巨人肩膀上，不斷推動學術研究的持續進步。',
        introduceFive:'核心功能',
        introduceSix:'智慧匹配檢索：實現我校重要評估來源成果中相似論文的高效發現。',
        introduceSeven:'跨語種檢索：透過向量化技術的應用，實現檢索與匹配不受語言限制。',
        introduceTen:'相似度最佳化排序：依論文的相似度呈現最佳配對結果，方便科學研究讀者快速定位最相關的研究成果。',
        introduceEight:'詳細資訊展示：平台提供檢索結果詳細的文獻資訊及外文成果的摘要譯文，方便使用者快速了解成果主旨。',
        introduceNine:'高時效性更新：平台定期同步重要評估來源資料庫，確保讀者能掌握最新的成果動態。',
        knowBtn:'我知道了',
        enter:'輸入',
        title:'成果智能發現平台－站在前輩肩膀上',
        tips:'請您輸入需要查詢文章的摘要或主題(篇名、關鍵字等) ，系統會幫您查找重點評價來源中我校的相似論文(中文無需專門翻譯轉換! )',
        submit:'提交',
        relatedLiterature:'相關文獻',
        year:'年份',

        enSummary:'英文摘要',
        cnSummary:'中文摘要',
    },
    chatdocument:{
        title:'深度文檔解析工具',
        introduce:'實現指定主題、範圍的文檔資料內容擷取和全文解析，從而輔助進行深度研究。',
        start:'開始體驗',
        ask:'文件提問，獲取你需要的答案',
        createSession:'建立會話，同時提問多個文檔',
        quoting:'引用段落，深入解析文獻內容',
        analyze:'解析圖表，擷取資料全面解析',
        tool:"高效率文檔解析助手",
        list:'文獻列表',
        conversation:'會話列表',
        createAsk:'建立會話',
        upload:'文件上傳',
        drag:'拖入文件或點擊上傳',
        introduceOne:'提問文件內容，透過聊天的形式即時取得答案。',
        introduceTwo:'ChatDocuments是一個文件解析助手，可以快速從文件中提取，定位和綜述資訊',
        quick:'快速訪問',
        enter:'請輸入內容...',
        askQuestion:'提問',
        example:'範例',
        busy:'服務繁忙，請重試',
        stop:'停止回答',
        onlyAsk:'僅對當前文章提問',
        chapter:'篇',
        create:'創建',
        editsession:'編輯會話',
        sessionname:'會話名稱',
        currentlyselected:'目前已選擇',
        fileselection:'文件選擇',
        revise:'修改',
        docLanguage:'文件語言',
        zhDoc:'中文文檔',
        enDoc:'英文文檔',
        support:'*僅支援上傳pdf文件',
        nowUpload:'正在上傳，請稍後...',
        question:'文檔語言不符合，無法選擇',
        editTitle:'雙擊編輯檔案名稱',

        uploadSuccess:'上傳成功',
        sideBar:'收縮側邊欄',
        noData:'文件中沒有找到可解析的表格',
        delConfirm:'確定刪除該檔案嗎?',
        unable:'無法對該excel進行解析',
        delSuccess:'刪除成功',
        selFile:'請選擇文件',
        inputName:'請輸入會話名稱',
        createSuccess:'創建成功',
        fileTips:'該文件正在轉換中，請稍後再試',
        failFile:'該檔案轉換失敗，請重新上傳',
        defaultQuestion1:'表格中包含了哪些字段，描述了什麼資料？',
        defaultQuestion2:'請計算出每列資料的平均值？',
        defaultQuestion3:'請計算出每列資料的中位數？',
        defaultQuestion4:'每列資料中出現次數最多的數值是？',
        defaultQuestion5:'從表格的數據中我們可以得到哪些信息，透過分析我們可以得到什麼結論？',
    },
    chatdata:{
        title:'深度資料智慧分析工具',
        introduce:'透過智慧解析和深度分析，為您揭示資料中的見解。 利用視覺化分析功能，實現圖表形式的生動展現。',
        start:'開始體驗',
        ask:'文件提問，獲取你需要的答案',
        create:'建立會話，同時提問多個文檔',
        quoting:'引用段落，深入解析文獻內容',
        analyze:'解析圖表，擷取資料全面解析',
        tool:"高效率文檔解析助手",
        list:'文獻列表',
        conversation:'會話列表',
        createAsk:'建立會話',
        upload:'文件上傳',
        drag:'拖入文件或點擊上傳',
        introduceOne:'ChatData透過表格及資料集的智慧解析，可以實現與表格對話式的提問。 並且透過深度分析可自動產生視覺化圖表，讓數據一目了然！',
        quick:'快速訪問',
        enter:'請輸入內容...',
        hint:'提示',
        hintOne:'在這個模組功能維護中，暫時無法使用，感謝您的理解和耐心等待',
        Isee:'我知道了',
    },
    chatopen:{
        title:'你的開放知識探索引擎',
        switch:'切換傳統檢索',
        introduce:'取得發現物理學、數學、電腦科學、人工智慧、統計等最新科學研究成果，掌握發展趨勢',
        features:'產品特點',
        featureOne:"利用人工智慧和先進技術為科學研究人員提供更有效率、更強大、更精準的知識發現體驗。 ChatOpen應用了語意檢索技術，實現深度理解讀者的搜尋意圖、興趣與跨語言只是映射。",
        featureTwo:'整合海量開放知識元數據，為科研讀者提供包括開放獲取文獻、預印本、等在內的多類型開源學術成果.結合語義發現，我們希望這些資源能夠助您推動學術科研創新，連接您與開放的未來。',
        translate:'翻譯',
        clear:'清空篩選'
    },
    message:{
        authority: "暫無權限",
        upload: "僅支援上傳 .jpg/.png 格式!",
        apply: "試用申請已提交,請耐心等待!",
        delete: "確定刪除該文件嗎?",
        size: "文件大小不能超過 20MB",
        wait: "正在處理中，請稍後"
    }
}